import { useContext } from 'react';

import { observer } from 'mobx-react-lite';

import { RootStoreContext } from 'index';
import FeaturesRestricted from 'components/MainLayout/GlobalModals/FeaturesRestricted/FeaturesRestricted';

const GlobalModals = () => {
  const { globalModalsStore } = useContext(RootStoreContext);
  const { isFeatureRestrictedOpen } = globalModalsStore;

  return <>{isFeatureRestrictedOpen && <FeaturesRestricted />}</>;
};

export default observer(GlobalModals);
